export enum CATALOG_CODE {
  UNIT_OF_MEASURE = 'UOM',
  UNLOAD_TYPE = 'ULT',
  TRANSPORT_METHOD = 'TPM',
  TIME_PER_LOAD = 'TPL',
  PUMP_CAPACITY = 'PCC',
  LOAD_SIZE = 'LSC',
  DISCHARGE_TIME = 'DCT',
  ADDITIONAL_SERVICE = 'ASC',
  ELEMENT = 'ELM',
  SLUMP = 'SPC',
  ADDITIONAL_PRODUCTS = 'APC',
  // Additional services
  CLEAN_UP = 'kicker',
  ADDITIONAL_PIPELINE = 'PIPESELECTION',
  MANEUVER = 'MANEUVERING',
}

export type CatalogCodeType =
  | CATALOG_CODE.UNIT_OF_MEASURE
  | CATALOG_CODE.UNLOAD_TYPE
  | CATALOG_CODE.TRANSPORT_METHOD
  | CATALOG_CODE.TIME_PER_LOAD
  | CATALOG_CODE.PUMP_CAPACITY
  | CATALOG_CODE.LOAD_SIZE
  | CATALOG_CODE.DISCHARGE_TIME
  | CATALOG_CODE.ADDITIONAL_SERVICE
  | CATALOG_CODE.ELEMENT
  | CATALOG_CODE.CLEAN_UP
  | CATALOG_CODE.ADDITIONAL_PIPELINE
  | CATALOG_CODE.SLUMP
  | CATALOG_CODE.ADDITIONAL_PRODUCTS
  | CATALOG_CODE.MANEUVER;
